import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {FormBuilder} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {CrudSavePopupComponent} from '../_directives';
import {AlertService, CampaignProductService, ResolveMerchantService} from '../_services';
import {
  CampaignProduct,
  DigitalReceipt,
  DigitalReceiptActionLink,
  DigitalReceiptActionTypeLabels,
  DigitalReceiptStatusCode,
  FulfillmentShipStatusChoices,
  FulfillmentStatus,
  MerchantProfileResolve,
} from '../_models';

@Component({
  selector: 'app-resolve-test-order',
  templateUrl: './resolve-test-order.component.html',
})
export class ResolveTestOrderComponent extends CrudSavePopupComponent implements OnInit {
  @Input('data') inputData: MerchantProfileResolve;
  @Output('selectProduct') onSelectProduct: EventEmitter<void> = new EventEmitter<void>();
  receipt: DigitalReceipt = null;
  receiptStatusCode = DigitalReceiptStatusCode;
  actionTypeLabels = DigitalReceiptActionTypeLabels;
  fulfillmentShipStatusChoices = FulfillmentShipStatusChoices;
  selectedProduct: CampaignProduct = null;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected resolveMerchantService: ResolveMerchantService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected campaignProductService: CampaignProductService
  ) {
    super(router, location, route, resolveMerchantService, alertService);
    this.objectName = 'Test Order';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({
      mark_shipped: [FulfillmentStatus.Shipped],
      campaign_products: [null],
    }));

    super.ngOnInit();
  }

  onSubmit() {
    this.submitted = true;
    this.receipt = null;

    if (this.inputData && this.inputData.id && this.form.valid) {
      this.loading = true;
      this.resolveMerchantService.sendTestOrder(this.inputData.id, this.getFormData())
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (receipt: DigitalReceipt) => {
            this.receipt = receipt;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.handleSubmitError(error);
          }
        );
    }
  }

  openActionLink(link: DigitalReceiptActionLink) {
    window.open(link.linkUrl, '_blank');
  }

  onProductSelected(productIds: string[]) {
    if (productIds.length) {
      this.campaignProductService.get(productIds[0])
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (product: CampaignProduct) => {
            this.selectedProduct = product;
            this.form.patchValue({ campaign_products: [product.id] });
          },
          (error) => {
            this.handleError(error);
          }
        );
    } else {
      this.selectedProduct = null;
      this.form.patchValue({ campaign_products: null });
    }
  }
}
